import { render, staticRenderFns } from "./JudgeListComponent.vue?vue&type=template&id=736e4f33&scoped=true&"
import script from "./JudgeListComponent.vue?vue&type=script&lang=js&"
export * from "./JudgeListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736e4f33",
  null
  
)

export default component.exports